var exports = {
  "P": "ProfileCardLayout.module__previewLabel___aVI0bE",
  "K": "ProfileCardLayout.module__profileCard___aVI0bE",
};

module.exports = exports;
